import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ToggleContentEditableComponent } from './toggle-content-editable/toggle-content-editable.component'
import { TranslationEditableDirective } from './translation-editable-directive.directive'
import { TranslateModule } from '@ngx-translate/core'
import { TranslationUpdateConfirmationComponent } from './translation-update-confirmation/translation-update-confirmation.component'
import { MatDialogModule } from '@angular/material/dialog'
import { TranslationEditableModalComponent } from './translation-editable-modal/translation-editable-modal.component'
import { TranslationEditableModalDirective } from './translation-editable-modal/translation-editable-modal.directive'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

@NgModule({
  declarations: [
    ToggleContentEditableComponent,
    TranslationEditableDirective,
    TranslationUpdateConfirmationComponent,
    TranslationEditableModalComponent,
    TranslationEditableModalDirective,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    ToggleContentEditableComponent,
    TranslationEditableDirective,
    TranslationEditableModalDirective,
  ],
  // entryComponents: [TranslationUpdateConfirmationComponent, TranslationEditableModalComponent]
})
export class ContentEditableModule {}
